export default [
    {
        id: "joining",
        message: "Confirm video settings",
        view: "confirm-join",
        hideToolbar: true,
        floating: true,
    },
];
